import { Component, Input, OnDestroy } from "@angular/core";
import { FormBuilder, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Subscription } from "rxjs";
import { isRack } from "src/services/item/rack.interface";
import { orderPreferencesFormFields } from "./order-preferences.form";
import { Preferences } from "src/services/order/order.interface";
import { Accommodation, Instruction } from "../../../../pages/schedule-trip/schedule-trip.constants";
import { BaseFormObjectComponent } from "../base-form-object.component";

@Component({
  selector: "rc-order-preferences-form-field",
  templateUrl: "./order-preferences-form-field.component.html",
  styleUrls: ["./order-preferences-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: OrderPreferencesFormFieldComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: OrderPreferencesFormFieldComponent,
    },
  ],
  standalone: false,
})
export class OrderPreferencesFormFieldComponent extends BaseFormObjectComponent<Preferences> implements OnDestroy {
  @Input() showScannerButton: boolean;
  @Input() size: "small" | "medium" | "large" = "medium";
  @Input() showAccommodation: boolean = true;

  public onChangeSubs: Subscription[] = [];
  public form = this.formBuilder.group({
    [orderPreferencesFormFields.accommodation]: null,
    [orderPreferencesFormFields.details]: null,
    [orderPreferencesFormFields.hotelName]: null,
    [orderPreferencesFormFields.instruction]: null,
    [orderPreferencesFormFields.reservationDetails]: null,
    [orderPreferencesFormFields.unitNumber]: null,
  });

  public constructor(private readonly formBuilder: FormBuilder) {
    super();
  }

  public ngOnDestroy() {
    for (const sub of this.onChangeSubs) {
      sub.unsubscribe();
    }
  }

  public registerOnChange(onChange: any) {
    const subForForm = this.form.valueChanges.subscribe(onChange);
    const subForDisplayValue = this.form.valueChanges.subscribe((event) => this.onInputChange(event));

    this.onChangeSubs.push(subForForm);
    this.onChangeSubs.push(subForDisplayValue);

    super.registerOnChange(onChange);
  }

  public setDisabledState(disabled: boolean) {
    if (disabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
    super.setDisabledState(disabled);
  }

  public async onInputChange(event: Partial<Preferences>): Promise<void> {
    if (!event || !isRack(event)) {
      return;
    }

    this.readOnlyValue = this.toDisplayValue(event);
  }

  public validate(): object | null {
    if (this.form.valid) {
      return null;
    }

    return this.getAllFormErrors();
  }

  public async writeValue(value: any): Promise<void> {
    if (value) {
      this.form.reset({ ...value }, { emitEvent: false });
    }
  }

  public toDisplayValue(_input: Preferences): string {
    return "";
  }

  public readonly accommodationValues = Object.values(Accommodation);
  public readonly Accommodation = Accommodation;
  public readonly Instruction = Instruction;
  public readonly instructionValues = Object.values(Instruction);
  public readonly accommodationFormFields = orderPreferencesFormFields;
}
